module.exports = __webpack_public_path__ + "Flama-UltralightItalic.woff2?ec6af9fde03da104efd414f9ad6b5d2e";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-UltralightItalic.woff2
// module id = 884
// module chunks = 0